import { Component, Input } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { HvacModeType } from 'src/app/core/models/hvac-mode-type.enum';
import { Property } from 'src/app/core/models/project/property.model';

@Component({
  selector: 'app-modal-view-heat-cool-auto',
  templateUrl: './modal-view-heat-cool-auto.component.html',
  styleUrl: './modal-view-heat-cool-auto.component.scss'
})
export class ModalViewHeatCoolAutoComponent {
  @Input({required: true}) controllers: Controller[];
  @Input() activeHvacModeGlobal: HvacModeType;
  Property = Property
  HvacModeType = HvacModeType;
  useHiddenFlag = true;

}
